import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";

// 1. IMPORTAMOS EL AUTOCOMPLETE (Ajusta la ruta si está en otra carpeta)
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";

export default function CrearBonificacion({
  onClose = () => {},
  onCreated = () => {},
}) {
  // --- ESTADOS DE CAMPOS ---
  const [nombre, setNombre] = useState("");
  const [cantidad, setCantidad] = useState("");
  const [rubroId, setRubroId] = useState("");
  
  // 2. CAMBIO DE ESTADO: Ahora guardamos el objeto completo de la EESS seleccionada
  const [selectedEess, setSelectedEess] = useState(null); 

  // --- ESTADOS DE CATÁLOGOS ---
  const [listas, setListas] = useState({
    rubros: [],
    // eess: [], <--- YA NO ES NECESARIO AQUÍ
  });

  const [saving, setSaving] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [error, setError] = useState("");

  // Lógica de validación
  const isValid = 
    nombre.trim() !== "" && 
    cantidad !== "" && 
    rubroId !== "";

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  // 3. CARGAR SOLO RUBROS (EESS se carga sola en el autocomplete)
  useEffect(() => {
    const cargarCombos = async () => {
      try {
        // Usamos el endpoint con paginación amplia para traer todos los rubros
        const urlRubros = apiRoutes.rubros.listUrl({ page: 0, size: 100 });
        const resRub = await appFetchJson(urlRubros);

        setListas({
          rubros: resRub?.items || [],
        });

      } catch (e) {
        console.error("Error cargando rubros:", e);
        setError("Error al cargar los rubros.");
      } finally {
        setLoadingData(false);
      }
    };
    cargarCombos();
  }, []);

  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);

    try {
      const payload = {
        nombre: nombre.trim(),
        cantidad: Number(cantidad),
        rubroId: Number(rubroId),
        
        // 4. EXTRAER ID DEL OBJETO SELECCIONADO (Si existe)
        eessId: selectedEess ? selectedEess.id : null, 
      };

      await appFetchJson(apiRoutes.bonificacion.create, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (onCreated) onCreated();
      onClose();

    } catch (e) {
      console.error("Error al crear:", e);
      setError(e?.message || "Ocurrió un error al guardar la bonificación.");
    } finally {
      setSaving(false);
    }
  };

  if (loadingData) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Bonificación</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">
            Introduzca los datos de la Bonificación
          </p>

          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}

          <div className="form-grid">
            
            {/* NOMBRE / DESCRIPCIÓN */}
            <div className="form-row">
              <label className="form-label">Descripción *</label>
              <input
                type="text"
                className="input"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Ej: Bonificación Autogas"
              />
            </div>

            {/* CANTIDAD */}
            <div className="form-row">
              <label className="form-label">Cantidad *</label>
              <InputNumberNoScroll
                className="input w-full h-[38px] bg-white border rounded px-3"
                value={cantidad}
                onChange={(e) => setCantidad(e.target.value)}
                placeholder="0.00"
              />
            </div>

            {/* RUBRO (Select Normal) */}
            <div className="form-row">
              <label className="form-label">Rubro *</label>
              <select
                className="input"
                value={rubroId}
                onChange={(e) => setRubroId(e.target.value)}
              >
                <option value="">--- Seleccione ---</option>
                {listas.rubros.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.nombre}
                  </option>
                ))}
              </select>
            </div>

            {/* 5. EE.SS. (Usando Autocomplete) */}
            <div className="form-row">
              <label className="form-label">Estación (EE.SS.)</label>
              <div className="w-full">
                <EessAutocomplete
                  value={selectedEess}
                  onChange={setSelectedEess}
                  placeholder="Buscar Estación..."
                />
              </div>
            </div>

          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label="Guardar"
              isValid={isValid}
              saving={saving}
              onClick={guardar}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}